export default __webpack_public_path__ + "static/media/feature-tests.e7cf553b.svg";